import { Link } from 'react-router-dom';

const NOTFOUND=()=>{
    return(
        <>
        <section>
            <div className="error-container">
                <div className="erro-body">
                    <div className="error-animate">🙁</div>
                    <h2 className="error-text-header"> صفحه ی مورد نظر یافت نشد.</h2>
                    <p className="error-text">
                        متاسفانه نتوانستیم صفحه مورد نظرتان را پیدا کنیم. پیشنهاد می کنیم به صفحه اصلی برگردید.
                    </p>
                    <Link className='btn' to={"https://www.toorangco.com/blog"} >
                        برگشت به صفحه اصلی
                    </Link>
                </div>
            </div>
        </section>
        </>
    );
};
export default NOTFOUND;